import dynamic from 'next/dynamic';

export { WrapperInactiveLogout } from './WrapperInactiveLogout';
// hydration error for logged users
export const InactiveMessage = dynamic(
  () => import('components/wrapperInactiveLogout/InactiveMessage').then((mod) => mod.InactiveMessage),
  { ssr: false }
);
